import React, { FC } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router';
import MainLayout from 'components/main-layout/MainLayout';
import API from 'core/Api';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { useTranslation } from 'react-i18next';
import StepOne from './components/StepOne';

const Screen: FC = () => {
  const { t } = useTranslation();
  const { client } = useActiveClientContext();
  const location = useLocation<{ isNew?: 0 | 1 }>();
  const isNewWizard = location.state?.isNew === 1;

  const { isLoading, error, data } = useQuery(buildClientEntity('step-one', client), () =>
    API.get<[]>(`document-wizard/step-one?new=${location.state?.isNew || 0}`).then(res => res.data)
  );

  return (
    <MainLayout
      title={t('docWizard.title')}
      isLoading={isLoading}
      error={error}
    >
      {data && (
        <StepOne
          data={data}
          isNewWizard={isNewWizard}
        />
      )}
    </MainLayout>
  );
};

export default Screen;
